/**
 * Client-facing default title for a shared preview file (task #73):
 * filename without extension, underscores/dots turned into spaces,
 * whitespace collapsed. Used by the PM dialog (prefill) and the server
 * (default when no title was set).
 */
export function cleanFileTitle(fileName: string): string {
  const base = fileName.replace(/\.[A-Za-z0-9]{1,8}$/, ''); // strip extension
  const cleaned = base.replace(/[_]+/g, ' ').replace(/\s+/g, ' ').trim();
  return (cleaned || fileName).slice(0, 255);
}
